import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Upload } from "antd";
import React, { useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";

// @ts-ignore
import builkcsv from "../../demo-files/test.csv";
import * as d3 from "d3";

type CSVData = {
  mobileNumbers: string[];
};

const SMSNotification = () => {
  const [loading, setLoading] = useState(false);
  const [fetchedCSVData, setFetchedCSVdata] = useState<CSVData | null>();

  const [form] = Form.useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    const readyData = data && {
      message: data.message,
      mobileNumbers: fetchedCSVData?.mobileNumbers || [],
    };

    await fetch(
      `${process.env.REACT_APP_NOTIFICATION_API}/sms/bulk-with-mask`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("SMS Sent Successfully", "success");
          resetData();
          setFetchedCSVdata(null);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const resetData = () => {
    // form?.resetFields();
    setFetchedCSVdata(null);
  };

  const simpleFileDownload = () => {
    window.location.href = `${builkcsv}`;
  };

  const handleUpload = async (data) => {
    const filteredData = [];
    data?.forEach((row) => {
      const mob = row.mobileNumber?.toString();
      if (mob) {
        filteredData.push(
          mob?.length === 10
            ? `+880${mob}`
            : mob?.length === 11
            ? `+88${mob}`
            : mob?.length === 13
            ? `+${mob}`
            : mob
        );
      }
    });
    setFetchedCSVdata({
      mobileNumbers: filteredData,
    });
  };

  const readUploadFile = (val) => {
    const mainFile = val?.fileList[0]?.originFileObj;

    if (mainFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        d3.csv(data).then((res) => {
          handleUpload(res);
          console.log("Contacts:", res);
        });
      };
      reader.readAsDataURL(mainFile);
    }
  };

  return (
    <React.Fragment>
      <div style={{ overflowY: "auto", height: "calc(100vh - 150px)" }}>
        <Row
          gutter={25}
          align="middle"
          justify="center"
          className="product-table"
        >
          <Col span={12}>
            <Card
              title="Send SMS"
              extra={
                <Button
                  onClick={simpleFileDownload}
                  type="dashed"
                  shape="round"
                >
                  <DownloadOutlined />
                  Sample File
                </Button>
              }
            >
              <Form layout="vertical" onFinish={onSubmit} form={form}>
                <Form.Item
                  hasFeedback
                  label="Message"
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: "Message is required",
                    },
                  ]}
                >
                  <Input.TextArea
                    rows={5}
                    id="message"
                    placeholder="Notification Message"
                  />
                </Form.Item>

                <div className="mb-4">
                  <Form.Item
                    hasFeedback
                    label=""
                    name="upload"
                    rules={[
                      {
                        required: true,
                        message: "File is required",
                      },
                    ]}
                  >
                    <Upload onChange={readUploadFile}>
                      <Button
                        type="dashed"
                        size="large"
                        shape="round"
                        danger
                        htmlType="button"
                        icon={<UploadOutlined />}
                      >
                        Upload Contacts (.csv)
                      </Button>
                    </Upload>
                  </Form.Item>
                  {/* <CSVReader
                    cssClass="react-csv-input"
                    label="Upload CSV File"
                    onFileLoaded={handleUpload}
                    parserOptions={papaparseOptions}
                  />{" "} */}
                </div>

                {fetchedCSVData?.mobileNumbers?.length >= 0 && (
                  <div className="mb-2 txt-red accent-txt">
                    Uploaded {fetchedCSVData?.mobileNumbers?.length} contacts
                  </div>
                )}

                <div className="buttons-container">
                  <Button
                    disabled={loading || !fetchedCSVData?.mobileNumbers?.length}
                    loading={(loading ? "loading" : undefined) as any}
                    type="primary"
                    htmlType="submit"
                    className="add-submit-btn text-center mr-2"
                  >
                    Send SMS
                  </Button>
                  <Button
                    type="ghost"
                    htmlType="button"
                    onClick={resetData}
                    className="reset-submit-btn text-center mr-2"
                  >
                    Reset
                  </Button>
                </div>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default SMSNotification;
